import { render, staticRenderFns } from "./sidebar_extend.vue?vue&type=template&id=ff4f8cec&scoped=true&"
import script from "./sidebar_extend.vue?vue&type=script&lang=js&"
export * from "./sidebar_extend.vue?vue&type=script&lang=js&"
import style0 from "./sidebar_extend.vue?vue&type=style&index=0&id=ff4f8cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4f8cec",
  null
  
)

export default component.exports